import React from 'react'
import './clients.css';
import adidas from '../../assets/adidas.png';
import advisory from '../../assets/advisory.png';
import asics from '../../assets/asics.png';
import amazon from '../../assets/amazon.png';
import fortnite from '../../assets/fortnite.png';
import gap from '../../assets/gap.png';
import jordan from '../../assets/jordan.png';
import netflix from '../../assets/netflix.png';
import newbalance from '../../assets/newbalance.png';
import puma from '../../assets/puma.png';
import sportif from '../../assets/sportif.png';
import spotify from '../../assets/spotify.png';
import vans from '../../assets/vans.png';
import wifi from '../../assets/wifi.png';
import harelydavidson from '../../assets/harelydavidson.png';
import nasa from '../../assets/nasa.png';
import { HiArrowNarrowRight } from 'react-icons/hi';


const Clients = () => {
  return (
       <div className='clients section_padding'>
          <div className='clients-container'>
              <h1 className='clients-heading'>A Few of Our Clients</h1>
              <div className='clients-logo-container'>
                  <div className='clients-logo'>
                     <img src={vans} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={nasa} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={adidas} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={advisory} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={amazon} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={asics} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={fortnite} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={gap} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={jordan} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={harelydavidson} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={netflix} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={newbalance} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={puma} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={sportif} alt='adidas' />
                  </div>
                  <div className='clients-logo'>
                     <img src={spotify} alt='adidas' />
                  </div>
                  
                  <div className='clients-logo'>
                     <img src={wifi} alt='adidas' />
                  </div>
              </div>
          </div>
      <div className='product-button'>
        <div className='product-button-content'>
          <a href='#product'>Meet Our Customers </a>
          <HiArrowNarrowRight className='arrow-icon' />

        </div>
      </div>
       </div>
  )
}

export default Clients